import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=69846ee0&scoped=true"
import script from "./tabbar.js?vue&type=script&lang=js&external"
export * from "./tabbar.js?vue&type=script&lang=js&external"
import style0 from "./tabbar.scss?vue&type=style&index=0&id=69846ee0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69846ee0",
  null
  
)

export default component.exports